import React from 'react';
import './Loading.scss';
import CircularProgress from '@mui/material/CircularProgress';

export const Loading = () => {
  return (
    <div
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '200px',
        marginTop: '100px',
        textAlign: 'center',
      }}
    >
      <CircularProgress />
    </div>
  );
};
